const ErrorLogs = ({ closeErrorLogs }) => {}

export default ErrorLogs;